export const EMPTY_VECTOR_TILE = {};

export const ICON_PAINTER_SCENECONFIG = {
    collision: true,
    fading: false,
    fadingDuration: 16 * 14,
    fadeInDelay: 600,
    fadeOutDelay: 100,
    uniquePlacement: false,
    depthFunc: 'always'
};
